module.exports = __webpack_public_path__ + "img/coffee-paste.e67f0d07.png";